/**
 * @generated SignedSource<<fee6449fd93b8241c8d300b612eda4fa>>
 * @relayHash 35e8d38ee7ce175327c96bc5ebd8b3db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1759738c65c97c1d86c0faf0688212cb9990ec80505ab3d5f3b5677bee7793b3

import type { ConcreteRequest } from 'relay-runtime';
export type useStatusUpdatesAutomationNudgeActionQuery$variables = {
  contentId: string;
};
export type useStatusUpdatesAutomationNudgeActionQuery$data = {
  readonly singleContent: {
    readonly ancestors: ReadonlyArray<{
      readonly id: string | null;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly title: string | null;
    } | null> | null;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly metadata: {
          readonly createdDate: string | null;
        };
        readonly title: string | null;
      } | null> | null;
    } | null;
    readonly id: string | null;
    readonly metadata: {
      readonly sourceTemplateEntityId: string | null;
    };
    readonly space: {
      readonly id: string | null;
    } | null;
    readonly title: string | null;
  } | null;
};
export type useStatusUpdatesAutomationNudgeActionQuery = {
  response: useStatusUpdatesAutomationNudgeActionQuery$data;
  variables: useStatusUpdatesAutomationNudgeActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "webui"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "sourceTemplateEntityId"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 25
          }
        ],
        "concreteType": "PaginatedContentList",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "createdDate"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "children(first:25)"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "35e8d38ee7ce175327c96bc5ebd8b3db",
    "id": "1759738c65c97c1d86c0faf0688212cb9990ec80505ab3d5f3b5677bee7793b3",
    "metadata": {},
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "operationKind": "query",
    "text": "query useStatusUpdatesAutomationNudgeActionQuery($contentId:ID!){singleContent(id:$contentId){id,title,space{id},ancestors{id,title,links{webui}},metadata{sourceTemplateEntityId},children(first:25){nodes{id,title,metadata{createdDate}}}}}"
  }
};
})();

(node as any).hash = "7d4350add1f37401d225556305e73d2a";

export default node;
